import notice from "../../utils/notice";
import { SPOTLIGHTS } from "../helpers/routes";
import {
  getMultipartParams,
  handleResponse,
  handleFormData,
} from "../helpers/validate";

export const getSpotlightsList = async (page = 1, per_page = 10) => {
  const params = new URLSearchParams({
    page: page.toString(),
    per_page: per_page.toString(),
  });

  return fetch(`${SPOTLIGHTS}/index?${params}`, getMultipartParams("GET"))
    .then((res) => handleResponse(res))
    .catch((e) => {
      notice("Error loading the spotlights list");
      throw e;
    });
};

export const createSpotlight = async (data) => {
  const formData = {
    ...data,
  };

  if (data.cover_url && data.cover_url instanceof File) {
    formData.file = data.cover_url;
  }

  delete formData.cover_url;

  const formDataToSend = handleFormData(formData);

  return fetch(
    `${SPOTLIGHTS}/create`,
    getMultipartParams("POST", formDataToSend)
  )
    .then((res) => handleResponse(res))
    .catch((e) => {
      notice("Error creating the spotlight");
      throw e;
    });
};

export const getSpotlight = async (id) => {
  return fetch(`${SPOTLIGHTS}/show/${id}`, getMultipartParams("GET"))
    .then((res) => handleResponse(res))
    .catch((e) => {
      notice("Error loading the spotlight");
      throw e;
    });
};

export const updateSpotlight = async (data) => {
  const formData = {
    ...data,
  };

  if (data.cover_url && data.cover_url instanceof File) {
    formData.file = data.cover_url;
  }

  delete formData.cover_url;

  const formDataToSend = handleFormData(formData);

  return fetch(
    `${SPOTLIGHTS}/update`,
    getMultipartParams("PUT", formDataToSend)
  )
    .then((res) => handleResponse(res))
    .catch((e) => {
      notice("Error updating the spotlight");
      throw e;
    });
};

export const deleteSpotlight = async (id) => {
  return fetch(`${SPOTLIGHTS}/delete/${id}`, getMultipartParams("DELETE"))
    .then((res) => handleResponse(res))
    .then((json) => {
      notice("Spotlight deleted", "success");
      return json;
    })
    .catch((e) => {
      notice("Error deleting Spotlight");
      console.error(e.errors);
      throw e;
    });
};
